import React from 'react';
import { FiCalendar, FiFileText } from 'react-icons/fi';
import { RiComputerLine } from 'react-icons/ri';
import { HiOutlineCheckCircle } from 'react-icons/hi';

export default function PatSummaryDashboardRow() {
  const documentationList = [
    'PAT register available',
    'PAT policy available',
    'Test certificates available',
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-7xl font-sans select-none">
      
      {/* 1. Review Information Card */}
      <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm flex flex-col justify-between min-h-[220px]">
        <div>
          {/* Card Header */}
          <div className="flex items-center space-x-3 text-blue-950 mb-5">
            <FiCalendar className="w-5 h-5 text-blue-900 flex-shrink-0" />
            <h3 className="font-bold text-base tracking-tight">Review Information</h3>
          </div>
          
          {/* Metadata Fields */}
          <div className="space-y-4 text-left">
            <div>
              <span className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                Review Date
              </span>
              <span className="text-base font-extrabold text-slate-900">
                18 Jul 2026
              </span>
            </div>
            
            <div>
              <span className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                Completed by
              </span>
              <span className="text-base font-extrabold text-slate-900">
                Arslan Nasir
              </span>
            </div>
          </div>
        </div>

        {/* Action Button */}
        <button className="w-full mt-6 py-2.5 border border-gray-200 rounded-xl bg-white hover:bg-slate-50 text-xs font-bold text-blue-600 transition shadow-sm">
          View previous review
        </button>
      </div>

      {/* 2. Appliance Summary Card */}
      <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm flex flex-col justify-between min-h-[220px]">
        <div>
          {/* Card Header */}
          <div className="flex items-center space-x-3 text-blue-950 mb-4">
            <RiComputerLine className="w-5 h-5 text-blue-900 flex-shrink-0" />
            <h3 className="font-bold text-base tracking-tight">Appliance Summary</h3>
          </div>

          {/* Metric Header Row */}
          <div className="flex items-end justify-between border-b border-gray-50 pb-3 mb-4">
            <div className="text-left">
              <span className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                Total Appliances
              </span>
              <span className="text-3xl font-black text-slate-900 tracking-tight">
                48
              </span>
            </div>
          </div>

          {/* Breakdown Status Rows */}
          <div className="space-y-3.5">
            {/* In Date row */}
            <div className="flex items-center justify-between text-xs">
              <div className="flex items-center space-x-3">
                <span className="w-2.5 h-2.5 rounded-full bg-emerald-600 inline-block" />
                <span className="font-semibold text-slate-700">In date</span>
              </div>
              <span className="font-bold text-emerald-600">47</span>
            </div>

            {/* Out of Date row */}
            <div className="flex items-center justify-between text-xs">
              <div className="flex items-center space-x-3">
                <span className="w-2.5 h-2.5 rounded-full bg-orange-500 inline-block" />
                <span className="font-semibold text-slate-700">Out of date</span>
              </div>
              <span className="font-bold text-orange-600">1</span>
            </div>

            {/* Not Tested row */}
            <div className="flex items-center justify-between text-xs">
              <div className="flex items-center space-x-3">
                <span className="w-2.5 h-2.5 rounded-full bg-red-500 inline-block" />
                <span className="font-semibold text-slate-700">Not tested</span>
              </div>
              <span className="font-bold text-red-600">0</span>
            </div>
          </div>
        </div>
      </div>

      {/* 3. PAT Documentation Card */}
      <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm flex flex-col min-h-[220px]">
        {/* Card Header */}
        <div className="flex items-center space-x-3 text-blue-950 mb-5">
          <FiFileText className="w-5 h-5 text-blue-900 flex-shrink-0" />
          <h3 className="font-bold text-base tracking-tight">PAT Documentation</h3>
        </div>

        {/* Verification Checkmarks List */}
        <div className="space-y-3.5 my-auto">
          {documentationList.map((doc, idx) => (
            <div key={idx} className="flex items-center space-x-3 text-xs">
              <HiOutlineCheckCircle className="w-4 h-4 text-emerald-600 flex-shrink-0" />
              <span className="font-semibold text-slate-700 text-left">
                {doc}
              </span>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
